var _excluded = ["className", "item", "items"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import AIcon from "../AIcon";
import "./ABreadcrumb.scss";
var ABreadcrumb = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var propsClassName = _ref.className,
    item = _ref.item,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    rest = _objectWithoutProperties(_ref, _excluded);
  var className = "a-breadcrumb",
    itemClassname = "".concat(className, "__item"),
    chevronClassname = "".concat(itemClassname, "__chevron"),
    arrowClassname = "".concat(itemClassname, "__arrow");
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  var template = item || function (x) {
    var _x$component = x.component,
      component = _x$component === void 0 ? "a" : _x$component,
      content = x.content,
      contentProps = x.contentProps;
    var TagName = component;
    return /*#__PURE__*/React.createElement(TagName, contentProps, content);
  };
  var singleLevelContent;
  if (items.length === 1) {
    var _ref2 = items[0].contentProps || {},
      href = _ref2.href,
      onClick = _ref2.onClick;
    var onArrowClick = function onArrowClick() {
      if (href) {
        window.location = href;
      }
      onClick && onClick();
    };
    singleLevelContent = /*#__PURE__*/React.createElement(AIcon, {
      className: arrowClassname,
      style: {
        cursor: "pointer"
      },
      onClick: onArrowClick
    }, "arrow-left");
  }
  return /*#__PURE__*/React.createElement("ul", _extends({}, rest, {
    ref: ref,
    className: className
  }), items.map(function (x, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: itemClassname
    }, singleLevelContent, index > 0 && /*#__PURE__*/React.createElement(AIcon, {
      className: chevronClassname
    }, "chevron-right"), template(x));
  }));
});
ABreadcrumb.propTypes = {
  /**
   * Sets a custom breadcrumb template.
   */
  item: PropTypes.func,
  /**
   * Sets the array of breadcrumb data objects.
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    component: PropTypes.elementType,
    content: PropTypes.node,
    contentProps: PropTypes.object
  }))
};
ABreadcrumb.displayName = "ABreadcrumb";
export default ABreadcrumb;